import {Component, Input, Signal} from '@angular/core';
import {ProjectsService} from "../../../services/projects.service";
import {CoreService} from "../../../services/core.service";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-thank-you-common',
  templateUrl: './thank-you-common.component.html',
  styleUrls: ['./thank-you-common.component.sass']
})
export class ThankYouCommonComponent {
  public sidebar = false;
  @Input() loading: boolean | Signal<void> = true;
  @Input() svgId: number = Math.floor(Math.random() * (1 + Math.random() * 1000));

  public globalLoading = true;
  public globalLoadingSignal: boolean | Signal<boolean> = this.projectService.globalLoadingSignal();

  constructor(
    private projectService: ProjectsService,
    private coreService: CoreService
  ) {
    this.coreService.enableThankYouPage();

    this.coreService.disableSidebar();

    this.coreService.globalLoading.subscribe((x: boolean) => {
      this.globalLoading = x;

    });

  }

  ngOnInit() {

    this.coreService.sidebar.subscribe(x => this.sidebar = x);
    //delay deactivation of globalLoading in order to avoid jumping layout
    setTimeout(() => {
      this.coreService.disableGlobalLoading();
    }, 700);
  }

  getLogoPath() {
    if (this.projectService.logo) {
      return this.projectService.logo;
    } else {
      return environment.defaultAppLogo;
    }
  }

  getApplicationName() {
    return this.projectService.getApplicationName();
  }

  loaded() {
    return this.globalLoadingSignal;
  }

}
